export default "__VITE_ASSET__MunEFiTO__"